export const SUITS = ['S', 'H', 'D', 'C'];
export const RANKS = ['2', '3', '4', '5', '6', '7', '8', '9', 'T', 'J', 'Q', 'K', 'A'];

export const SUIT_INFO = {
  S: { symbol: '♠', name: 'spades', color: 'black' },
  H: { symbol: '♥', name: 'hearts', color: 'red' },
  D: { symbol: '♦', name: 'diamonds', color: 'red' },
  C: { symbol: '♣', name: 'clubs', color: 'black' }
};

export const RANK_NAMES = {
  2: 'Two', 3: 'Three', 4: 'Four', 5: 'Five', 6: 'Six', 7: 'Seven', 8: 'Eight', 9: 'Nine',
  T: 'Ten', J: 'Jack', Q: 'Queen', K: 'King', A: 'Ace'
};

export function createDeck() {
  return SUITS.flatMap(suit => RANKS.map(rank => `${rank}${suit}`));
}

export function cryptoIndex(max) {
  if (!Number.isInteger(max) || max <= 0) throw new Error('max must be a positive integer');
  const limit = Math.floor(0x100000000 / max) * max;
  const bucket = new Uint32Array(1);
  let value;
  do {
    crypto.getRandomValues(bucket);
    value = bucket[0];
  } while (value >= limit);
  return value % max;
}

export function shuffle(cards = createDeck(), indexer = cryptoIndex) {
  const result = [...cards];
  for (let i = result.length - 1; i > 0; i -= 1) {
    const j = indexer(i + 1);
    [result[i], result[j]] = [result[j], result[i]];
  }
  return result;
}

export function cardParts(card) {
  const rank = card[0];
  const suit = card[1];
  if (!RANKS.includes(rank) || !SUITS.includes(suit)) throw new Error(`Invalid card: ${card}`);
  return { rank, suit, ...SUIT_INFO[suit], rankName: RANK_NAMES[rank] };
}

export function cardLabel(card) {
  const { rankName, name } = cardParts(card);
  return `${rankName} of ${name}`;
}
